import { Button, Spinner } from '@themesberg/react-bootstrap'
import React from 'react'

function CustomButton({
  loading = false,
  variant = "primary",
  type = "button",
  children,
  disabled,
  ...rest
}) {
  return (
    <Button
      variant={variant}
      type={type}
      disabled={loading || disabled}
      {...rest}
    >
      {loading ? "Please wait..." : children}
    </Button>
  );
}

export default CustomButton
